var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3263 1.74536H21.6998L14.3297 9.4669L23 19.9742H16.2112L10.894 13.6016L4.80995 19.9742H1.43443L9.31743 11.7151L1 1.74536H7.96111L12.7674 7.57017L18.3263 1.74536ZM17.1423 18.1232H19.0116L6.94539 3.49907H4.93946L17.1423 18.1232Z",
    fill: "#0F1111",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d61869627023e8a1c550bc366431f66e.svg";
export { ForwardRef as ReactComponent };